import React, { useState, useEffect } from 'react';
import { ModalWrapper, STUDENTHistoryTable } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Space, Row, Col, Select } from 'antd';
import { CheckOutlined } from '@ant-design/icons'
import { useStudentHistory } from 'hooks';
import SearchBox from './SearchBox'

export interface StudentHistoryModalProps extends PopupProps {
    name_kor: string;
    phone: string
}

const StudentHistoryModal = ({ 
    isOpen, 
    onClose, 
    name_kor, phone}: StudentHistoryModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

  const [searchParams, setSearchParams] = useState<any>({});

  /* ======================================================
  * hooks
  * ====================================================== */
  const {historyList, searchResult} = useStudentHistory(name_kor, phone, searchParams);        
   /* ======================================================
   * variables
   * ====================================================== */

   /* ======================================================
   * events
   * ====================================================== */

    const onCloseClick = () => {
        onClose?.();
    }

    const onSearch = (params: any) => {
        setSearchParams(params);
    }

    const onChangePageInfo = (pageNo: number, pageSize: number) => {
        setSearchParams({...searchParams, pageNo, pageSize})
      };      
  /* ======================================================
   * effects
   * ====================================================== */
 
    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={1000} title={"교육생 히스토리"} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <div>
                <h3>{name_kor}님에 대한 검색 결과 입니다.</h3>
            </div>
            <SearchBox onSearch={onSearch} /> 
            <STUDENTHistoryTable historyList={historyList} searchResult={searchResult} onChangePageInfo={onChangePageInfo} />
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(StudentHistoryModal);    